import AxiosManager from "../../../util/axiosLib/axiosManager";
import apiManager from "@/taylorCommon/apiManager";


var apiUrl=process.env.VUE_APP_apiUrl +"/";
// var apiUrl="http://127.0.0.1:8000/";
// var apiUrl= "https://kianseng.org/"
// var apiPathBase="api/test/";
var apiPathBase="api/firegodsec/";
// var apiPathBase="api/admin/";





export default {
    //---------------axios------------------------
    getAxiosManager(){
        return new AxiosManager("sessionkey" + "tokenkey")
    },
    //---------------------------------------

    //---------------------------------------
    getApiManager() {
        return new apiManager(apiUrl,apiPathBase,"",this.getAxiosManager(),null)
    },
    api_Admin_Product_Query ()
    {
        let data={
        }

        return this.getApiManager().api_CallMethod_ByParamObj("Admin_Product_Query",data)
    },

    api_Admin_Product_Save (datas)
    {
        let data={
            json:JSON.stringify(datas)
        }

        return this.getApiManager().api_CallMethod_ByParamObj("Admin_Product_Save",data)
    },

    api_Admin_ProductOrder_Query ( status)
    {
        let data={
            status:status,
        }

        return this.getApiManager().api_CallMethod_ByParamObj("Admin_ProductOrder_Query",data)
    },
    api_Admin_ProductOrder_Get ( id)
    {
        let data={
            id:id,
        }

        return this.getApiManager().api_CallMethod_ByParamObj("Admin_ProductOrder_Get",data)
    },
    api_Admin_ProductOrder_ChangeStaus ( id,status)
    {
        let data={
            id:id,
            status:status,
        }

        return this.getApiManager().api_CallMethod_ByParamObj("Admin_ProductOrder_ChangeStaus",data)
    },

    api_Admin_ProductOrder_Delete ( id)
    {
        let data={
            id:id,
        }

        return this.getApiManager().api_CallMethod_ByParamObj("Admin_ProductOrder_Delete",data)
    },

    api_Admin_ECOrderList_Query ( status)
    {
        let data={
            status:status,
        }

        return this.getApiManager().api_CallMethod_ByParamObj("Admin_ECOrderList_Query",data)
    },


    api_Admin_ECOrderList_ChangeStaus ( id,status)
    {
        let data={
            id:id,
            status:status,
        }

        return this.getApiManager().api_CallMethod_ByParamObj("Admin_ECOrderList_ChangeStaus",data)
    },

    api_Admin_Users_List ()
    {
        let data={
        }

        return this.getApiManager().api_CallMethod_ByParamObj("Admin_Users_List",data)
    },

    api_Admin_Users_Save ( user)
    {
        let data=user;

        return this.getApiManager().api_CallMethod_ByParamObj("Admin_Users_Save",data)
    },
    api_Admin_Users_Delete ( user)
    {
        let data=user;

        return this.getApiManager().api_CallMethod_ByParamObj("Admin_Users_Delete",data)
    },
    //---------------------------------------
    api_Admin_AdminUsers_List ()
    {
        let data={
        }

        return this.getApiManager().api_CallMethod_ByParamObj("Admin_AdminUsers_List",data)
    },

    api_Admin_AdminUsers_Save ( user)
    {
        let data=user;

        return this.getApiManager().api_CallMethod_ByParamObj("Admin_AdminUsers_Save",data)
    },
    api_Admin_AdminUsers_Delete ( user)
    {
        let data=user;

        return this.getApiManager().api_CallMethod_ByParamObj("Admin_AdminUsers_Delete",data)
    },

    api_Admin_AdminUsers_Enable ( user)
    {
        let data=user;

        return this.getApiManager().api_CallMethod_ByParamObj("Admin_AdminUsers_Enable",data)
    },

    //---------------------------------------
    api_Admin_EventDefine2_Query ( )
    {
        let data= {};

        return this.getApiManager().api_CallMethod_ByParamObj("Admin_EventDefine2_Query",data)
    },
    api_Admin_EventDefine2_Get (id )
    {
        let data= {
            id:id
        };

        return this.getApiManager().api_CallMethod_ByParamObj("Admin_EventDefine2_Get",data)
    },
    api_Admin_EventDefine2_Save ( product)
    {
        let data={
            json:JSON.stringify(product)
        }

        return this.getApiManager().api_CallMethod_ByParamObj("Admin_EventDefine2_Save",data)
    },
    api_Admin_EventDefine2_Del (id )
    {
        let data= {
            id:id
        };

        return this.getApiManager().api_CallMethod_ByParamObj("Admin_EventDefine2_Del",data)
    },
    api_Admin_EventDefine2_Disable (id )
    {
        let data= {
            id:id
        };

        return this.getApiManager().api_CallMethod_ByParamObj("Admin_EventDefine2_Disable",data)
    },
    //---------------------------------------

    api_Admin_ECProduct_Query ( )
    {
        let data= {};

        return this.getApiManager().api_CallMethod_ByParamObj("Admin_ECProduct_Query",data)
    },
    api_Admin_ECProduct_SaveOrder (products )
    {
        let data= {
            json:JSON.stringify(products)
        };

        return this.getApiManager().api_CallMethod_ByParamObj("Admin_ECProduct_SaveOrder",data)
    },
    api_Admin_ECProduct_Get (id )
    {
        let data= {
            id:id
        };

        return this.getApiManager().api_CallMethod_ByParamObj("Admin_ECProduct_Get",data)
    },
    api_Admin_ECProduct_Save ( product)
    {
        let data={
            json:JSON.stringify(product)
        }

        return this.getApiManager().api_CallMethod_ByParamObj("Admin_ECProduct_Save",data)
    },
    api_Admin_ECProduct_Del (id )
    {
        let data= {
            id:id
        };

        return this.getApiManager().api_CallMethod_ByParamObj("Admin_ECProduct_Del",data)
    },
    api_Admin_ECProduct_ChangeIsActive (id,isActive )
    {
        let data= {
            id:id,
            isActive:isActive
        };

        return this.getApiManager().api_CallMethod_ByParamObj("Admin_ECProduct_ChangeIsActive",data)
    },
    // api_Admin_ECProduct_UploadImages ( )
    // {
    //     let data= {};
    //
    //     return this.getApiManager().api_CallMethod_ByParamObj("Admin_Admin_ECProduct_UploadImages",data)
    // },

    api_Admin_ECProduct_GetCategories ( )
    {
        let data= {};

        return this.getApiManager().api_CallMethod_ByParamObj("Admin_ECProduct_GetCategories",data)
    },
}
